module.exports = __webpack_public_path__ + "media/images/badges/cyclebar/red/RideClub_Milestones_App_1000-Red-e64b2cdd2e388c08eebace4167258484.png";